import { ReactNode } from 'react';
import { AxiosError } from 'axios';

import { useToastStore, ToastProps } from 'stores/use-toast-store';

type ShowProps = Omit<ToastProps, 'id'> & {
	timeout?: number;
};

type VariantFuncProps = {
	content: ReactNode | AxiosError | string;
};

type UseToastProps = {
	info: ({ content }: VariantFuncProps) => void;
	success: ({ content }: VariantFuncProps) => void;
	warning: ({ content }: VariantFuncProps) => void;
	error: ({ content }: VariantFuncProps) => void;
};

export const useToast = () => {
	const { addToast, removeToast } = useToastStore((state) => ({
		addToast: state.addToast,
		removeToast: state.removeToast,
	}));

	const show = ({
		variant = 'info',
		content,
		timeout = 10000,
	}: ShowProps) => {
		const id =
			new Date().getUTCMilliseconds() +
			Math.random().toString(36).substring(2, 15);

		addToast({ id, variant, content });

		setTimeout(() => {
			removeToast(id);
		}, timeout);
	};

	return {
		info: ({ content }) => show({ variant: 'info', content }),
		success: ({ content }) => show({ variant: 'success', content, timeout: 6000 }),
		warning: ({ content }) => show({ variant: 'warning', content }),
		error: ({ content }) => show({ variant: 'error', content }),
	} as UseToastProps;
};
